<template>
  <div class="homepage-wrapper">
    <div class="home-top-row">
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">Aktivni predmeti</div>
        <div class="predmeti-zadaci-number">       
          <div class="zadaci-number">{{row_analytics.active_cases}}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-positive">+4%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">Arhivirani predmeti</div>
        <div class="predmeti-zadaci-number">       
          <div class="zadaci-number">{{row_analytics.archived_cases}}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-positive">+12%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">Potrebna pažnja</div>
        <div class="predmeti-zadaci-number">       
          <div class="zadaci-number">{{row_analytics.important_events}}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-negative">-15%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">Nadolazeći događaji</div>
        <div class="predmeti-zadaci-number">       
          <div class="zadaci-number">{{row_analytics.upcoming_events}}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-positive">+20%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">Aktivni projekti</div>
        <div class="predmeti-zadaci-number">       
          <div class="zadaci-number">{{row_analytics.active_projects}}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-negative">-20%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">Arhivirani projekti</div>
        <div class="predmeti-zadaci-number">       
          <div class="zadaci-number">{{row_analytics.archived_projects}}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-positive">+20%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
    </div>
    <div class="home-columns-wrapper">
      <div class="two-columns-wrapper">
        <div class="home-first-column hc">
          <div class="aktualni-predmeti section">
            <div class="section-title aktualni-predmeti-title">
              Moji predmeti
            </div>
            <div v-if="fetching" class="center-spinner">
              <svg class="dot-spin" viewBox="0 0 50 50">
                  <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
              </svg>
            </div>
            <div v-else class="cases-main-wrapper">
              <div class="cases-row row-title-row">
                <div
                  class="cases-column cases-column1"
                  style="opacity: 1 !important"
                >
                  Br. predmeta
                  <div class="downarrow"></div>
                </div>
                <div
                  class="cases-column cases-column2"
                  style="opacity: 1 !important; transform: none !important"
                >
                  Datum
                  <div class="downarrow"></div>
                </div>
                <div class="cases-column cases-column3">
                  Stranka
                  <div class="downarrow"></div>
                </div>
                <div class="cases-column cases-column4">
                  Naziv predmeta
                  <div class="downarrow"></div>
                </div>
              </div>
              <div class="cases-inner-wrapper">
                <div
                  v-for="(single_case, key) in homepage_cases"
                  :key="key"
                  class="cases-row"
                >
                  <div class="cases-column cases-column1">
                  <router-link :to="'case/' + single_case.group_url + '/'">
                    <b>{{ single_case.broj_predmeta }}</b></router-link>
                  </div>
                  <div class="cases-column cases-column2">
                    {{ getDate(single_case.datum_pocetka) }}
                  </div>
                  <div class="cases-column cases-column3">
                    <a
                      href="#"
                      v-if="
                        single_case.prav_connect_stranka.length == 0 &&
                        single_case.connect_fiz_stranka.length == 0
                      "
                      >N/A</a
                    >
                    <router-link
                      :to="
                        '/osobe/prav/' +
                        single_case.prav_connect_stranka[0].pravna_osoba.uid
                      "
                      v-if="single_case.prav_connect_stranka.length > 0"
                      >{{
                        single_case.prav_connect_stranka[0].pravna_osoba.ime
                      }}
                    </router-link>
                    <router-link
                      :to="
                        '/osobe/fiz/' +
                        single_case.connect_fiz_stranka[0].fizicka_osoba.uid
                      "
                      v-if="
                        single_case.connect_fiz_stranka.length > 0 &&
                        single_case.prav_connect_stranka.length == 0
                      "
                    >
                      {{ single_case.connect_fiz_stranka[0].fizicka_osoba.ime }}
                      {{
                        single_case.connect_fiz_stranka[0].fizicka_osoba.prezime
                      }}</router-link
                    >

                    <v-tooltip
                      right
                      v-if="
                        single_case.connect_fiz_stranka.length +
                          single_case.prav_connect_stranka.length >
                        1
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                        <img
                          v-bind="attrs"
                          v-on="on"
                          class="more-dots"
                          src="@/assets/img/more.svg"
                        />
                      </template>
                      <p
                        v-for="(
                          stranka, key
                        ) in single_case.connect_fiz_stranka"
                        :key="'1' + key"
                      >
                        {{ stranka.fizicka_osoba.ime }}
                        {{ stranka.fizicka_osoba.prezime }}
                      </p>
                      <p
                        v-for="(
                          stranka, key
                        ) in single_case.prav_connect_stranka"
                        :key="'2' + key"
                      >
                        {{ stranka.pravna_osoba.ime }}
                      </p>
                    </v-tooltip>
                  </div>
                  <div class="cases-column cases-column4">
                    <v-tooltip v-if="single_case.ime_predmeta.length >= 23" top>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="zadatak-naziv" v-bind="attrs" v-on="on">
                          <router-link :to="'case/' + single_case.group_url + '/'">{{ single_case.ime_predmeta.slice(0, 32) }}...</router-link> 
                        </div>
                      </template>
                      <div class="zadatak-naziv">
                      <router-link :to="'case/' + single_case.group_url + '/'">
                      {{ single_case.ime_predmeta }}</router-link> 
                      </div>
                    </v-tooltip>
                    <span v-else><router-link :to="'case/' + single_case.group_url + '/'">{{ single_case.ime_predmeta }}</router-link></span>
                  </div>
                </div>
                <div
                  class="predmeti-svi pogledaj-sve"
                  @click="$store.state.view_cases_by_logged_person=true;$router.push('/cases')"
                >
                  pogledaj sve
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="analitika section">
          <div class="section-title analitika-title">Analitika
            <div class="analitika-dropdown">
              <select id="search-group">
                <option value="prihodi">Prihodi</option>
                <option value="rashodi">Rashodi</option>
              </select>
              <img
                class="calendar-arrow"
                src="@/assets/img/strelica_dupla.svg"
              />
            </div>
          </div>
          <div class="analitika-graf">
            <img src="@/assets/img/analitika.jpg"/>
          </div>
        </div> -->
          <div class="mini-column-wrapper">
            <div class="row-column hc">
              <KalendarEventsSection
                :key="refreshKey+1"
                @taskIzvrsen="refreshEvents"
                @dontRefresh="catchIsEmitting"
                :event_type="'Moji rokovi'"
                :event_data="
                  all_events.filter((event) => event.uid_event_type == 4)
                "
              />
            </div>
            <div class="row-column hc">
              <KalendarEventsSection
                :key="refreshKey+2"
                @taskIzvrsen="refreshEvents"
                @dontRefresh="catchIsEmitting"
                :event_type="'Moja ročišta'"
                :event_data="
                  all_events.filter((event) => event.uid_event_type == 2)
                "
              />
            </div>
          </div>
        </div>
        <div class="home-second-column hc">
          <KalendarEventsSection
            :key="refreshKey+3"
            @taskIzvrsen="refreshEvents"
            @dontRefresh="catchIsEmitting"
            :event_type="'Moji zadaci'"
            :event_data="
              all_events.filter((event) => event.uid_event_type == 1)
            "
          />
          <KalendarEventsSection
            :key="refreshKey+4"
            @taskIzvrsen="refreshEvents"
            @dontRefresh="catchIsEmitting"
            :event_type="'Moji sastanci'"
            :event_data="
              all_events.filter((event) => event.uid_event_type == 3)
            "
          />
          <!-- <div class="posljednja-aktivnost section">
          <div class="section-title">Posljednja aktivnost</div>
            <div class="case-aktivnost-clan">
              <div class="aktivnost-dot indikator i-g"></div>
              <div class="case-team-member-img case-team-member1"></div>
              <div class="case-aktivnost-txts">
                <div class="case-aktivnost-txt">
                  <b>Marko M.</b> dodao je novi zadatak<span class="role"
                    >prije 5 minuta</span
                  >
                </div>
              </div>
              <div class="furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div> 
            <div class="case-aktivnost-clan">
              <div class="aktivnost-dot indikator i-g"></div>
              <div class="case-team-member-img case-team-member2"></div>
              <div class="case-aktivnost-txts">
                <div class="case-aktivnost-txt">
                  <b>Suzana C.</b> dodala je novi zadatak<span class="role"
                    >prije 1 sat</span
                  >
                </div>
              </div>
              <div class="furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div> 
            <div class="case-aktivnost-clan">
              <div class="aktivnost-dot indikator"></div>
              <div class="case-team-member-img case-team-member3"></div>
              <div class="case-aktivnost-txts">
                <div class="case-aktivnost-txt">
                  <b>Dmitar T.</b> dodao je novi račun<span class="role"
                    >22.11.2020 16:40</span
                  >
                </div>
              </div>
              <div class="furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="case-aktivnost-clan">
              <div class="aktivnost-dot indikator"></div>
              <div class="case-team-member-img case-team-member3"></div>
              <div class="case-aktivnost-txts">
                <div class="case-aktivnost-txt">
                  <b>Dmitar T.</b> riješio je zadatak<span class="role"
                    >22.11.2020 19:20</span
                  >
                </div>
              </div>
              <div class="furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="case-aktivnost-clan">
              <div class="aktivnost-dot indikator"></div>
              <div class="case-team-member-img case-team-member3"></div>
              <div class="case-aktivnost-txts">
                <div class="case-aktivnost-txt">
                  <b>Dmitar T.</b> dodao je novi dokument<span class="role"
                    >21.11.2020 21:30</span
                  >
                </div>
              </div>
              <div class="furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
        </div> -->
        </div>
      </div>
      <div class="home-third-column">
        <!-- <div class="case-predmet-right-rightpt"> -->
        <MiniCalendar ref="mini_kalendar" />
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import autocomplete from "@/components/generalComponents/autocomplete.vue";
import KalendarEventsSection from "@/components/calendarComponents/KalendarEventsSection.vue";
import auth from "@/services/auth";
import MiniCalendar from "@/components/calendarComponents/MiniCalendar.vue";
import ms_calendar from "@/apiCallers/calendarSharepoint";
import person from "@/apiCallers/person";
import {refreshLogoutTimer} from "@/plugins/timer.js"
import moment from "moment";
// import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
export default {
  components: { autocomplete, MiniCalendar, KalendarEventsSection },
  data() {
    return {
      accessToken: "",
      all_events: [],
      homepage_cases: [],
      row_analytics: {
        active_cases: 0,
        archived_cases: 0,
        important_events: 0,
        upcoming_events: 0,
        active_projects: 0,
        archived_projects: 0,
      },
      fetching:true,
      is_emitting:false,
      sioVar: {
        type: {},
        required: false,
        default: null,
      },
      lawyer_id:null,
      refreshKey:0,
      // all_pers: [],
    };
  },
  watch:{
    sioVar: function (){
      if (this.sioVar != null) {
        this.sioVar.socket.on("update task", async () => {
          if (!this.is_emitting) {
            this.refreshEvents();
            this.refreshAnalytics();
          }
        });
      }
    },
    "$store.state.sioVar":function () {
      if (this.$store.state.sioVar != null) {
        this.sioVar = this.$store.state.sioVar
      }
    }
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES).catch(()=>
    {
      currentUser = auth.user()
      // if(!currentUser)
        location.reload();
    });
    
    var full_user_data = await person.getSelf(this.accessToken);
    console.log("full lawyer data",full_user_data.data.predmet_odvjetnik_connector.map(p=>p.predmet))
    this.lawyer_id = full_user_data.data.uid;
    var tmp_cases = full_user_data.data.predmet_odvjetnik_connector.map(p=>p.predmet);
    this.homepage_cases = tmp_cases;
    this.fetching=false;
    await  ms_calendar
      .getPersonEvents(this.accessToken, this.lawyer_id)
      .then((resp) => {
        this.all_events = resp.data;
        console.log(this.all_events.filter((event) => event.uid_event_type == 1));
      });
    this.refreshAnalytics();
    // predmet_hand
    //   .getAll(this.accessToken, 1, 0, 0, 4, null, null, false)
    //   .then((response) => {
    //     this.fetching=false;
    //     console.log(response.data.full_case_list);
    //     this.homepage_cases = response.data.full_case_list;
    //     //table return animation
    //     // gsap.to(".responstable", 0.5, { opacity: 1, x: 0 });
    //   });
    this.sioVar = this.$store.state.sioVar
  },
  methods: {
    fullLogout() {
      auth.clearLocal();
      auth.logout();
      this.$router.push({ path: "/login" });
    },
    refreshAnalytics(){
      person.getSelfAnalytics(this.accessToken).then((resp) => {
        this.row_analytics = resp.data
    });
    },
    getDate(fullDateTime) {
      return moment(fullDateTime).format("DD.MM.YYYY");
    },
    catchIsEmitting(){
      this.is_emitting = true;
    },
    refreshEvents(event){
      this.all_events = this.all_events.filter((ev)=>ev != event);
      ms_calendar
      .getPersonEvents(this.accessToken, this.lawyer_id)
      .then((resp) => {
        this.all_events = resp.data;
        this.refreshKey++;
      });
      this.is_emitting = false;
    }
  },
  mounted() {
    refreshLogoutTimer()
    // this.all_events = this.$refs.mini_kalendar.$data

    // osobe.getAllOsobe().then((resp) => {
    //   console.log(resp.data);
    //   resp.data.forEach((p) => {
    //     this.all_pers.push({
    //       link: p.url,
    //       value: p.ime + " " + p.prezime,
    //       uloga: p.uloga,
    //       email: p.email,
    //     });
    //   });
    // });
    this.$store.state.paginacija.title = "Upravljačka ploča";
  },
};
</script>

<style>
</style>